import { AlertCircle, Sparkles } from "lucide-react";

interface StickyTotalAmountBarProps {
  finalAmount: number;
  originalAmount?: number;
  savings?: number;
}

const formatAmount = (amount: number) => `₹${amount.toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;

const StickyTotalAmountBar: React.FC<StickyTotalAmountBarProps> = ({ finalAmount, originalAmount, savings }) => {
  const showOriginalAmount = Number(originalAmount) > 0 && originalAmount !== finalAmount;
  const showSavings = Number(savings) > 0;

  return (
    <div className="ml-[63px] mr-[58px] mt-[16px] font-roboto">
      <div className="overflow-hidden rounded-[16px] bg-[#141414] text-white shadow-[0_8px_24px_rgba(0,0,0,0.12)]">
        <div className="flex items-center justify-between gap-5 px-5 pb-2.5 pt-3">
          {showSavings && (
            <div className="flex shrink-0 items-center gap-2 rounded-full bg-[#EAF7E4] px-4 py-2 text-[20px] font-semibold text-[#409C18]">
              <Sparkles className="h-[18px] w-[18px]" />
              You saved {formatAmount(Number(savings))}
            </div>
          )}
          <div className="ml-auto flex min-w-0 flex-col items-end">
            <p className="text-[14px] font-medium uppercase tracking-[0.08em] text-[#C9CDD4]">Total Amount</p>
            <div className="mt-1 flex items-baseline gap-2">
              {showOriginalAmount && (
                <span className="text-[18px] text-[#8A8F98] line-through">{formatAmount(Number(originalAmount))}</span>
              )}
              <span className="text-[34px] font-bold leading-none">{formatAmount(finalAmount)}</span>
            </div>
          </div>
        </div>
        <div className="flex items-center justify-end gap-2 bg-[#FFC24D] px-5 py-1.5">
          <AlertCircle className="h-[18px] w-[18px] shrink-0 text-[#3D2E00]" />
          <p className="truncate text-[18px] font-semibold text-[#3D2E00]">Do Not Pay until the <span className="font-bold">Bill</span> is created.</p>
        </div>
      </div>
    </div>
  );
};

export default StickyTotalAmountBar;
